import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'iss-drawer-content',
  standalone: true,
  templateUrl: './drawer-content.component.html',
  styleUrls: [ './drawer-content.component.scss' ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DrawerContentComponent {}
